var fragmentShaders = {
    // dbz:'void main(void) {\n' +
    //     '   vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n' +
    //     '   if(texelColour.g == 1.0){' +
    //     '       gl_FragColor = vec4(0.0,0.0,0.0,0.0);'+
    //     '   }else{' +
    //     '   vec4 gradientColor = texture2D(uColorMapTexture, vec2(texelColour.g, 0.5));\n' +
    //     '   if(texelColour.g>0.0){\n' +
    //     '    gradientColor.a =(1.0 - gradientColor.b);\n' +
    //     '   }else{\n' +
    //     '    gradientColor.a =0.0;\n' +
    //     '   }\n' +
    //     '   \n' +
    //     '   \n' +
    //     '   if(gradientColor.a>0.3){' +
    //     '      gradientColor.a=1.0;' +
    //     '   }'+
    //     '   gl_FragColor = vec4(gradientColor.rgb*gradientColor.a,gradientColor.a);\n' +
    //     '   }'+
    //     '  }'
    dbz: `void main(void) {
        if(texture2D( uRaster0,vUV).g == 1.0 || texture2D( uRaster0,vUV).b == 0.4){
            gl_FragColor = vec4(0.0);
        }else if(texture2D(uRaster0,vUV).g == 0.0){
                gl_FragColor = vec4(0.1,0.1,0.1,0.2);
        }else{
            float f = 0.0;
            float dv = 1.0/20800.0;
            float tot = 0.0;
            float value = 0.0;
            
            
            float valueSpan = 0.0;
            for(float i = -1.0; i <= 1.0; ++i)
            {
                for(float j = -1.0; j <= 1.0; ++j)
                {
                    
                    f = (1.1 - sqrt(i*i + j*j)/8.0);
                    f *= f;
                    tot += f;
                    float valueXy = texture2D( uRaster0, vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;
                    float valueXy1 = texture2D( uRaster0, vec2(vUV.x + j*dv*5.0, vUV.y + i*dv*5.0) ).g;
                    if(valueXy1 >= 0.9){
                        gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                        return;
                    }
                    
                    value += valueXy;
                }
            }
            value /= tot;
            
            if(value == 1.0){
                gl_FragColor = vec4(0.0);
            }else{   
                vec4 gradientColor1 = texture2D(colorMap, vec2(value*4.0, 0.5));
                if(value>0.0){
                    gradientColor1.a =(1.0 - gradientColor1.b);
                    
                    if(gradientColor1.a<0.1){
                        gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                    }else{
                        gl_FragColor = vec4(gradientColor1.rgb*gradientColor1.a,gradientColor1.a);
                    }
                    
                }else{
                    gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                }
            }
        }
        
    }`,
    dbz_play: `
    void main(void) {
        float pp = uNow;
       
        
        float currValue = 0.0;
        float currNextValue = 0.0;
        
        currValue = texture2D( uRaster0,vUV).g;
        currNextValue = texture2D( uRaster1,vUV).g;
        
        if(currValue == 1.0 && currNextValue == 1.0){
            gl_FragColor = vec4(0.0);
        }else if(currValue == 0.0 && currNextValue== 0.0){
                gl_FragColor = vec4(0.1,0.1,0.1,0.2);
        }else{
            float f = 0.0;
            float dv = 1.0/20800.0;
            float tot = 0.0;
            float value = 0.0;
            float value1 = 0.0;
            
            float valueSpan = 0.0;
            
            
            for(float i = -2.0; i <= 2.0; ++i)
            {
                for(float j = -2.0; j <= 1.0; ++j)
                {
                    
                    f = (1.1 - sqrt(i*i + j*j)/8.0);
                    f *= f;
                    tot += f;
                    
                    
                    
                    float valueXy = 0.0;
                    float valueXyNext = 0.0;
                    
                    float valueXy1 = 0.0;
                    
                    float cc = 4.0;
                    valueXy = texture2D( uRaster0, vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;
                    valueXyNext = texture2D( uRaster1, vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;
                    valueXy1 = texture2D( uRaster0, vec2(vUV.x + j*dv*3.0, vUV.y + i*dv*cc) ).g;
                    
                    if(valueXy1 >= 0.9){
                        gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                        return;
                    }
                    
                    value += valueXy;
                    value1 += valueXyNext;
                }
            }
            value /= tot;
            value1 /= tot;
            
            value = mix(value,value1,pp/timeSpan);
            
            if(value == 1.0){
                gl_FragColor = vec4(0.0);
            }else{   
                vec4 gradientColor1 = texture2D(colorMap, vec2(value*4.0, 0.5));
                if(value>0.0){
                    gradientColor1.a =(1.0 - gradientColor1.b);
                    
                    if(gradientColor1.a<0.1){
                        gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                    }else{
                        gl_FragColor = vec4(gradientColor1.rgb*gradientColor1.a,gradientColor1.a);
                    }
                    
                }else{
                    gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                }
            }
        }
        
    }`,
    dbz_play1: `void main(void) {
        float pp = mod(uNow,$(totalTime));//6000.0
        
        float textureIndex = -1.0;
        
        float timeSpanParam = timeSpan;
        if(timeSpanParam!=3000.0 && timeSpanParam!=1500.0){
            timeSpanParam = 1500.0;
        }
        
        if(uNow>=0.0){
            textureIndex = floor(pp/timeSpanParam);
        }
        
        
        float currValue = 0.0;
        float currNextValue = 0.0;
        
        $(judgeCode1)
        
        if(currValue == 1.0 && currNextValue == 1.0){
            gl_FragColor = vec4(0.0);
        }else if(currValue == 0.0 && currNextValue== 0.0){
                gl_FragColor = vec4(0.1,0.1,0.1,0.2);
        }else{
            float f = 0.0;
            float dv = 1.0/20800.0;
            float tot = 0.0;
            float value = 0.0;
            float value1 = 0.0;
            
            float valueSpan = 0.0;
            
            
            for(float i = -1.0; i <= 1.0; ++i)
            {
                for(float j = -1.0; j <= 1.0; ++j)
                {
                    
                    f = (1.1 - sqrt(i*i + j*j)/8.0);
                    f *= f;
                    tot += f;
                    
                    
                    
                    float valueXy = 0.0;
                    float valueXyNext = 0.0;
                    
                    float valueXy1 = 0.0;
                    
                    float cc = 4.0;
                    
                    $(judgeCode2)else{
                        valueXy = texture2D( uRaster0, vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;
                        valueXyNext = texture2D( uRaster0, vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;
                    }
                    
                    if(valueXy1 >= 0.9){
                        gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                        return;
                    }
                    
                    value += valueXy;
                    value1 += valueXyNext;
                }
            }
            value /= tot;
            value1 /= tot;
            
            value = mix(value,value1,(mod(pp,timeSpanParam+0.1)/timeSpanParam));
            
            if(value == 1.0){
                gl_FragColor = vec4(0.0);
            }else{   
                vec4 gradientColor1 = texture2D(colorMap, vec2(value*4.0, 0.5));
                if(value>0.0){
                    gradientColor1.a =(1.0 - gradientColor1.b);
                    
                    if(gradientColor1.a<0.1){
                        gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                    }else{
                        gl_FragColor = vec4(gradientColor1.rgb*gradientColor1.a,gradientColor1.a);
                    }
                    
                }else{
                    gl_FragColor = vec4(0.1,0.1,0.1,0.2);
                }
            }
        }
        
    }`,

    getFragmentSgader: function(type, totalNum) {

        if (type == "dbz_play1") {

            if (totalNum <= 1) {
                return this[type.replace("_play", "")];
            }

            //雷达实况和预报时间差
            var timeSpan = 10 * playSpeed_top;

            //计算总时长
            var totalTime = (totalNum * timeSpan) + ".0";

            var judgeCode1 = "" +
                "if(textureIndex == 0.0){\n" +
                "   currValue = texture2D( uRaster0,vUV).g;\n" +
                "   currNextValue = texture2D( uRaster1,vUV).g;\n" +
                "}";
            var judgeCode2 = "" +
                "if(textureIndex == 0.0){\n" +
                "   valueXy = texture2D( uRaster0, vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;\n" +
                "   valueXyNext = texture2D( uRaster1, vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;\n" +
                "   valueXy1 = texture2D( uRaster0, vec2(vUV.x + j*dv*3.0, vUV.y + i*dv*cc) ).g;\n" +
                "}";

            for (var p = 1; p < totalNum; p++) {
                var nextIndex = p + 1;
                if (nextIndex > totalNum - 1) {
                    nextIndex = 0;
                }

                judgeCode1 += "" +
                    "else if(textureIndex == " + p + ".0){\n" +
                    "   currValue = texture2D( uRaster" + p + ",vUV).g;\n" +
                    "   currNextValue = texture2D( uRaster" + nextIndex + ",vUV).g;\n" +
                    "}";

                judgeCode2 += "" +
                    "else if(textureIndex == " + p + ".0){\n" +
                    "   valueXy = texture2D( uRaster" + p + ", vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;\n" +
                    "   valueXyNext = texture2D( uRaster" + nextIndex + ", vec2(vUV.x + j*dv, vUV.y + i*dv) ).g*f;\n" +
                    "   valueXy1 = texture2D( uRaster" + p + ", vec2(vUV.x + j*dv*3.0, vUV.y + i*dv*cc) ).g;\n" +
                    "}";

                if (p == totalNum - 1) {
                    judgeCode1 += "\n";
                    judgeCode2 += "\n";
                }

            }

            return this[type].replace("$(judgeCode1)", judgeCode1)
                .replaceAll("$(judgeCode2)", judgeCode2)
                .replaceAll("$(totalTime)", totalTime)
                .replaceAll("$(timeSpan)", timeSpan + ".0")


        } else {
            return this[type];
        }
    }
}

var glColor = {
    dbz: {
        /*
          0.04:"rgb(40, 16, 255)",
          0.05:"rgb(17,137,159)",
          0.06:"rgb(14,158,159)",
          0.08:"rgb(19,159,89)",
          0.10:"rgb(15,154,48)",
          0.12:"rgb(70, 205, 96)",
          0.14:"rgb(195, 219, 38)",
          0.16:"rgb(245, 203, 8)",
          0.18:"rgb(244, 159, 33)",
          0.21:"rgb(223, 102, 68)",
          0.24:"rgb(190, 52, 94)",
          0.27:"rgb(157, 16, 109)",
          0.30:"rgb(117, 0, 107)",
          0.35:"rgb(87, 0, 94)",
          0.4:"rgb(87, 0, 94)"
          */
        0.04: "rgb(40, 16, 255)",
        // 0.06: "rgb(17,137,159)",
        // 0.08: "rgb(14,158,159)",
        0.1: "rgb(19,159,89)",
        // 0.15: "rgb(15,154,48)",
        0.2: "rgb(70, 205, 96)",
        0.25: "rgb(195, 219, 38)",
        0.3: "rgb(245, 203, 8)",
        // 0.35: "rgb(244, 159, 33)",
        0.4: "rgb(223, 102, 68)",
        0.45: "rgb(190, 52, 94)",
        0.5: "rgb(157, 16, 109)",
        // 0.55: "rgb(117, 0, 107)",
        // 0.6: "rgb(87, 0, 94)",
        0.7: "rgb(87, 0, 94)"
    }
}

window.glColor = glColor;
window.fragmentShaders = fragmentShaders;